<template>
  <div class="pubAreaAffiliation">
    <van-loading size="24px" vertical v-if="showLoading">加载中...</van-loading>
    <div class="dutyMsg" id="dutyMsg" v-if="!showLoading">
      <div class="msgList" v-if="this.recordData != ''">
        <ul>
          <!-- <li>
            <p class="clearfix">
              <span>{{ $t("oneLOneD.zeqmjTit") }}</span>
              <span>{{ $t("common.hectare") }}</span>
            </p>
            <p>{{ recordData.gridArea == null ? "0" : recordData.gridArea }}</p>
            <p>
              {{
                recordData.gridName == null
                  ? $t("oneLOneD.withoutZrqTip")
                  : recordData.gridName
              }}
            </p>
          </li> -->
          <li class="foresM">
            <p class="clearfix">
              <span>{{ $t("oneLOneD.lindiMjTit") }}</span>
              <span>{{ $t("common.hectare") }}</span>
            </p>
            <p>
              {{
                recordData.xiaoBanInfoResult == null
                  ? "0"
                  : recordData.xiaoBanInfoResult.xiaoBanArea
              }}
            </p>
            <p class="clearfix">
              <span
                >{{ $t("common.forestXiaoBan") }}
                {{
                  recordData.xiaoBanInfoResult == null
                    ? "0"
                    : recordData.xiaoBanInfoResult.xiaoBanNumber
                }}
                个</span
              >
              <span
                >{{ $t("common.forestCoverage") }}
                {{
                  recordData.xiaoBanInfoResult == null
                    ? ""
                    : recordData.xiaoBanInfoResult.fractionCoverage
                }}
                %</span
              >
            </p>
          </li>
          <li>
            <p class="clearfix">
              <span>{{ $t("wetlandMsg.MainJiTit") }}</span>
              <span>{{ $t("common.hectare") }}</span>
            </p>
            <p>
              {{
                recordData.shidiInfoResult == null
                  ? "0"
                  : recordData.shidiInfoResult.shiDiArea
              }}
            </p>
            <p>
              <span
                >{{ $t("common.wetlandXiaoBan") }}
                {{
                  recordData.shidiInfoResult == null
                    ? "0"
                    : recordData.shidiInfoResult.shiDiNumber
                }}
                个</span
              >
            </p>
          </li>
          <!-- <li class="oldtree" v-if=" this.recordData.gushuList.lenght !=0 "> -->
          <li class="oldtree">
            <p class="clearfix">
              <span> {{ $t("common.oldAndFamousTrees") }}</span>
              <span> {{ $t("common.plant") }}</span>
            </p>
            <p>
              {{
                recordData.gushuListCount == "" ? 0 : recordData.gushuListCount
              }}
            </p>
            <p class="gsmm clearfix">
              <span v-for="(item, index) in recordData.gushuList" :key="index"
                >{{ item.gsDj }}
                {{ item.gsDjNumber ? item.gsDjNumber : "0" }}</span
              >
            </p>
          </li>
          <!-- <li>
            <p class="clearfix">
              <span>{{ $t("common.linZhang") }}</span>
              <span>{{ $t("common.a") }}</span>
            </p>
            <p>{{ recordData.lzCount }}</p>
            <p>
              {{ $t("common.ranger") }} {{ recordData.ylyyCount }}
              {{ $t("common.a") }}
            </p>
          </li> -->
          <!-- <li>
            <p class="clearfix">
              <span>{{ $t("common.cooperativeUnit") }}</span>
              <span>{{ $t("common.a") }}</span>
            </p>
            <p>
              {{
                recordData.xtdwInfoResult == null
                  ? "0"
                  : recordData.xtdwInfoResult.xtdwCount
              }}
            </p>
            <p>
              {{
                recordData.xtdwInfoResult == null ||
                recordData.xtdwInfoResult.xtdwCount == "0"
                  ? ""
                  : recordData.xtdwInfoResult.xtdwName
              }}
            </p>
          </li> -->
        </ul>
        <div class="eChartDataBox">
          <h5>{{ $t("searchMsg.lindiTit") }}</h5>
          <div class="forsetChart barUnit" v-if="this.diData">
            <!-- 地类 -->
            <p>{{ $t("common.dileiTit") }}</p>
            <span class="units">单位：小班</span>
            <gg-bar-chart :sourceList="diData"></gg-bar-chart>
          </div>
          <div class="woodsChart cicleUnit" v-if="this.woodsData">
            <!-- 森林类别 -->
            <p>{{ $t("common.senLinLbTit") }}</p>
            <span class="units">单位：小班</span>
            <gg-cicle-chart :sourceList="woodsData"></gg-cicle-chart>
          </div>
          <div class="gChengChart barUnit" v-if="this.gchengData">
            <!-- 工程类别 -->
            <p>{{ $t("oldTree.gchengLb") }}</p>
            <span class="units">单位：小班</span>
            <gg-bar-chart :sourceList="gchengData"></gg-bar-chart>
          </div>
          <div class="linZChart barUnit" v-if="this.linZData">
            <!-- 林种类别 -->
            <p>{{ $t("oldTree.linZhongLb") }}</p>
            <span class="units">单位：小班</span>
            <gg-bar-chart :sourceList="linZData"></gg-bar-chart>
          </div>
          <h5 v-if="this.sDiData">{{ $t("searchMsg.shidiTit") }}</h5>
          <div class="linZChart barUnit" v-if="this.sDiData">
            <!-- 工程类别 -->
            <p>{{ $t("wetlandMsg.DiXingTit") }}</p>
            <span class="units">湿地数量：个</span>
            <gg-bar-chart :sourceList="sDiData"></gg-bar-chart>
          </div>
          <h5 v-if="this.oldTreeData[0]">古树名木</h5>
          <div class="gChengChart" v-if="this.oldTreeData[0]">
            <p>保护等级</p>
            <span class="units">单位：颗</span>
            <!-- <gg-cicle-chart :sourceList="oldTreeData"></gg-cicle-chart> -->
            <gg-cicle-chart-two :sourceList="oldTreeData"></gg-cicle-chart-two>
          </div>
        </div>
      </div>
    </div>
    <div class="nonePage" v-if="this.recordData == ''">
      <img :src="nonePng" alt />
      <p>{{ $t("common.noDataTip") }}</p>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import nonePng from "@/assets/none.png";
const ggBarChart = () => import("@/components/common/barChart");
const ggCicleChart = () => import("@/components/common/cicleChart");
const ggCicleChartTwo = () => import("@/components/common/cicleChartTwo");
export default {
  name: "pubResource",
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  data() {
    return {
      nonePng: nonePng, //默认图片
      showLoading: true,
      zrqObjid: "",
      zrqLevel: "",
      zqCode: "",
      recordData: {
        gridArea: "",
        gridName: "",
        xiaoBanInfoResult: {
          xiaoBanArea: "",
          xiaoBanNumber: "",
          fractionCoverage: "",
          coverageArea: "",
        },
        shidiInfoResult: { shiDiArea: "", shiDiNumber: "" },
        gushuList: [],
        lzCount: "",
        ylyyCount: "",
        xtdwInfoResult: { xtdwCount: "", xtdwName: "" },
      },
      dataList: [],
      diData: [], //地类
      woodsData: [], //森林类别
      gchengData: [], //工程类别
      linZData: [], //林种类别
      sDiData: [], //湿地类别
      oldTreeData: [], //古树列表
    };
  },
  components: {
    ggBarChart,
    ggCicleChart,
    ggCicleChartTwo,
  },
  mounted() {
    this.showLoading = false;

    this.$nextTick(function () {
      if (this.dataInfo.objid && this.dataInfo.type) {
        this.zrqObjid = this.dataInfo.objid;
        this.zrqLevel = this.dataInfo.level;
        this.zqCode = this.dataInfo.zqCode;
        this.initRecord();
      }
    });

    // this.$nextTick(() => {
    //   this.initRecord();
    // });
  },
  methods: {
    initRecord() {
      let _this = this;
      _this.$api.pubZrq
        .myGridStatistics({
          type: this.dataInfo.areaType,
          zqCode: _this.zqCode,
          objId: _this.zrqObjid,
          level: _this.zrqLevel,
        })
        .then((res) => {
          if (res.code == "1") {
            if (res.data == null || res.data.gridArea == null) {
              _this.recordData = "";
            } else {
              if (res.data.gushuList[0]) {
                res.data.gushuList.forEach((item) => {
                  let itemInfo = {
                    type: item.gsDj,
                    numbers: Number(item.gsDjNumber),
                  };
                  _this.oldTreeData.push(itemInfo);
                });
              }
              if (res.data.gushuList == 0 || res.data.gushuList == null) {
                // _this.zrqName = res.data.zqName;
                _this.$set(_this.recordData, "gushuListCount", 0);
                let data = [
                  {
                    gsDjNumber: 0,
                    gsDj: "古树",
                  },
                  {
                    gsDjNumber: 0,
                    gsDj: "名木",
                  },
                ];
                res.data.gushuList == null
                  ? (res.data.gushuList = [])
                  : (res.data.gushuList = []);
                res.data.gushuList = res.data.gushuList.concat(data);
              } else {
                let count =
                  Number(res.data.gushuList[0].gsDjNumber) +
                  Number(res.data.gushuList[1].gsDjNumber);
                _this.$set(_this.recordData, "gushuListCount", count);
              }
              

              _this.recordData = Object.assign({}, _this.recordData, res.data);
              _this.initChart();
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initChart() {
      let _this = this;
      _this.$api.pubZrq
        .gridStatisticalChart({
          objid: _this.zrqObjid,
          zqCode: _this.zqCode,
          zqLevel: _this.zrqLevel,
          areaType: this.dataInfo.areaType,
        })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);

            //地类
            if (res.data.diLeiList.length > 0) {
              _this.diData = res.data.diLeiList;
            } else {
              _this.diData = null;
            }
            //森林地类
            if (res.data.senLinLbList.length > 0) {
              _this.woodsData = res.data.senLinLbList;
            } else {
              _this.woodsData = null;
            }
            //工程
            if (res.data.gchengLbList.length > 0) {
              _this.gchengData = res.data.gchengLbList;
            } else {
              _this.gchengData = null;
            }
            //林种
            if (res.data.linZhongList.length > 0) {
              _this.linZData = res.data.linZhongList;
            } else {
              _this.linZData = null;
            }
            //湿地
            if (res.data.shiDiXingList.length > 0) {
              _this.sDiData = res.data.shiDiXingList;
            } else {
              _this.sDiData = null;
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    dataInfo: {
      handler: function () {
        if (this.dataInfo.objid && this.dataInfo.type) {
          this.zrqObjid = this.dataInfo.objid;
          this.zrqLevel = this.dataInfo.level;
          this.zqCode = this.dataInfo.zqCode;
          this.initRecord();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.pubAreaAffiliation {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  position: relative;
  overflow: hidden;
  .nonePage {
    width: 120px;
    height: 150px;

    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -75px;

    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
  .dutyMsg {
    width: 100%;
    height: 100%;
    overflow: scroll;
    .currentZrqPosition {
      margin-bottom: 8px;

      .van-field__left-icon {
        color: #4bc985;
      }
      .van-cell__title {
        width: 120px;
        span {
          font-size: 15px;
          color: #626064;
        }
      }
      .van-cell__value {
        .van-field__control {
          text-align: right;
          font-size: 15px;
          color: #999;
        }
      }
    }
    .msgList {
      ul {
        margin-bottom: 20px;
        li:first-child {
          margin-top: 0;
        }
        li {
          width: 100%;
          padding: 5px 16px;
          background-color: #fff;
          margin: 8px 0;
          p {
            margin-top: 8px;
            span {
              font-size: 14px;
              color: #999;
            }
          }
          p:first-child {
            span:first-child {
              font-weight: 600;
              float: left;
            }
            span:last-child {
              float: right;
            }
          }
          p:nth-child(2) {
            border-bottom: 1px solid #f4f4f4;
            line-height: 25px;
            color: #4bc985;
            font-size: 16px;
            text-align: left;
            margin: 5px 0;
          }
          p:last-child {
            color: #979696;
            line-height: 20px;
            opacity: 0.6;
            font-size: 14px;
          }
        }

        li.oldtree {
          p:last-child {
            width: 100%;
            span:first-child {
              float: left;
            }
            span:last-child {
              float: right;
            }
          }
        }
        li.foresM {
          p:last-child {
            span:first-child {
              float: left;
            }
            span:last-child {
              float: right;
            }
          }
        }
      }
      .eChartDataBox {
        padding: 0 16px;
        background-color: #fff;
        h5 {
          font-size: 18px;
          line-height: 22px;
          color: #666;
        }
        p {
          text-align: center;
          font-size: 16px;
          color: #666;
        }
        .barUnit {
          position: relative;
          .units {
            position: absolute;
            top: 50px;
            left: 0;
            color: #666;
            font-size: 10px;
          }
        }
        .cicleUnit {
          position: relative;
          .units {
            position: absolute;
            top: 60px;
            right: 10px;
            color: #666;
            font-size: 10px;
          }
        }
      }
    }
  }
}
</style>